import { render, staticRenderFns } from "./shortMessage.vue?vue&type=template&id=066bc8cf&scoped=true&"
import script from "./shortMessage.vue?vue&type=script&lang=js&"
export * from "./shortMessage.vue?vue&type=script&lang=js&"
import style0 from "./shortMessage.vue?vue&type=style&index=0&id=066bc8cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066bc8cf",
  null
  
)

export default component.exports